function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M0 0h60v60H0z"
}), React.createElement("rect", {
  width: 2.632,
  height: 65.789,
  x: 28.684,
  y: -1.895,
  fill: "#FFF",
  rx: 1.316,
  transform: "rotate(45 30 31)"
}), React.createElement("rect", {
  width: 2.632,
  height: 65.789,
  x: 28.684,
  y: -1.895,
  fill: "#FFF",
  rx: 1.316,
  transform: "rotate(-45 30 31)"
}));

var SvgIcClose = function SvgIcClose(props) {
  return React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ic-close.5da0b94f.svg";
export { SvgIcClose as ReactComponent };